const HTTP_ERROR_RECOVERY_TIMEOUT_MS = 2000

let recoveryTimeout: ReturnType<typeof setTimeout> | null = null

export const useHttpErrorRecovery = () => {
  const isRecoveringFromHttpError = useState('is-recovering-from-http-error', () => false)

  const stopHttpErrorRecovery = () => {
    isRecoveringFromHttpError.value = false

    if (recoveryTimeout) {
      clearTimeout(recoveryTimeout)
      recoveryTimeout = null
    }
  }

  const startHttpErrorRecovery = () => {
    if (!import.meta.client) return

    isRecoveringFromHttpError.value = true

    const router = useRouter()
    const unregister = router.afterEach(() => {
      unregister()
    })

    if (recoveryTimeout) clearTimeout(recoveryTimeout)
    recoveryTimeout = setTimeout(stopHttpErrorRecovery, HTTP_ERROR_RECOVERY_TIMEOUT_MS)
  }

  return {
    isRecoveringFromHttpError,
    startHttpErrorRecovery,
    stopHttpErrorRecovery
  }
}
